// Mock function implementations
export const bookAppointment = async (params) => {
  await new Promise(resolve => setTimeout(resolve, 2000));
  const { date, time, service, customerName, customerEmail } = params;
  
  if (new Date(`${date}T${time}`) < new Date()) {
    return { success: false, message: "Cannot book appointments in the past" };
  }

  return {
    success: true,
    message: `Appointment booked for ${customerName} on ${date} at ${time} for ${service}`,
    data: {
      appointmentId: `APT-${Date.now()}`,
      date, time, service, customerName, customerEmail,
      status: 'confirmed'
    }
  };
};

export const transferToHuman = async (params) => {
  await new Promise(resolve => setTimeout(resolve, 1000));
  const { reason, priority = 'medium', department = 'support' } = params;
  
  return {
    success: true,
    message: `Transferring to ${department} team (${priority} priority). Reason: ${reason}`,
    data: {
      transferId: `TXF-${Date.now()}`,
      department, priority, reason,
      estimatedWaitTime: priority === 'high' ? '1-2 minutes' : '3-5 minutes'
    }
  };
};

export const getOrderStatus = async (params) => {
  await new Promise(resolve => setTimeout(resolve, 1500));
  const { orderId, customerEmail } = params;
  const statuses = ['processing', 'shipped', 'delivered', 'cancelled'];
  const randomStatus = statuses[Math.floor(Math.random() * statuses.length)];
  
  return {
    success: true,
    message: `Order ${orderId} is currently ${randomStatus}`,
    data: {
      orderId, status: randomStatus,
      trackingNumber: randomStatus === 'shipped' ? `TRK${Date.now()}` : null,
      estimatedDelivery: randomStatus === 'shipped' ? '2-3 business days' : null
    }
  };
};

export const sendEmail = async (params) => {
  await new Promise(resolve => setTimeout(resolve, 1000));
  const { recipient, subject, template } = params;
  
  return {
    success: true,
    message: `Email sent to ${recipient} using ${template} template`,
    data: {
      emailId: `EMAIL-${Date.now()}`,
      recipient, subject, template,
      sentAt: new Date().toISOString()
    }
  };
};

export const createSupportTicket = async (params) => {
  await new Promise(resolve => setTimeout(resolve, 1500));
  const { customerEmail, subject, description, priority = 'medium', category = 'general' } = params;
  
  return {
    success: true,
    message: `Support ticket created: #${Date.now()}`,
    data: {
      ticketId: `TICKET-${Date.now()}`,
      customerEmail, subject, description, priority, category,
      status: 'open',
      createdAt: new Date().toISOString()
    }
  };
};